import * as yup from 'yup';

export const pinCodeSchema = yup.object().shape({
  pinCode: yup.string().matches(/^([0-9]{6})$/),
});
